module.exports = __webpack_public_path__ + "assets/37bc7099f6f1ba80236164f22e905837.svg";